// React SVG camelCase → standard SVG attribute mapping.
// Only includes entries where the React name differs from the SVG attribute name.
// Canonical source: https://github.com/facebook/react/blob/main/packages/react-dom-bindings/src/shared/possibleStandardNames.js
export const REACT_SVG_PROPS: Record<string, string> = {
	accentHeight: "accent-height",
	alignmentBaseline: "alignment-baseline",
	arabicForm: "arabic-form",
	baselineShift: "baseline-shift",
	capHeight: "cap-height",
	clipPath: "clip-path",
	clipRule: "clip-rule",
	colorInterpolation: "color-interpolation",
	colorInterpolationFilters: "color-interpolation-filters",
	colorProfile: "color-profile",
	colorRendering: "color-rendering",
	dominantBaseline: "dominant-baseline",
	enableBackground: "enable-background",
	fillOpacity: "fill-opacity",
	fillRule: "fill-rule",
	floodColor: "flood-color",
	floodOpacity: "flood-opacity",
	fontFamily: "font-family",
	fontSize: "font-size",
	fontSizeAdjust: "font-size-adjust",
	fontStretch: "font-stretch",
	fontStyle: "font-style",
	fontVariant: "font-variant",
	fontWeight: "font-weight",
	glyphName: "glyph-name",
	glyphOrientationHorizontal: "glyph-orientation-horizontal",
	glyphOrientationVertical: "glyph-orientation-vertical",
	horizAdvX: "horiz-adv-x",
	horizOriginX: "horiz-origin-x",
	imageRendering: "image-rendering",
	letterSpacing: "letter-spacing",
	lightingColor: "lighting-color",
	markerEnd: "marker-end",
	markerMid: "marker-mid",
	markerStart: "marker-start",
	overlinePosition: "overline-position",
	overlineThickness: "overline-thickness",
	paintOrder: "paint-order",
	pointerEvents: "pointer-events",
	renderingIntent: "rendering-intent",
	shapeRendering: "shape-rendering",
	stopColor: "stop-color",
	stopOpacity: "stop-opacity",
	strikethroughPosition: "strikethrough-position",
	strikethroughThickness: "strikethrough-thickness",
	strokeDasharray: "stroke-dasharray",
	strokeDashoffset: "stroke-dashoffset",
	strokeLinecap: "stroke-linecap",
	strokeLinejoin: "stroke-linejoin",
	strokeMiterlimit: "stroke-miterlimit",
	strokeOpacity: "stroke-opacity",
	strokeWidth: "stroke-width",
	textAnchor: "text-anchor",
	textDecoration: "text-decoration",
	textRendering: "text-rendering",
	transformOrigin: "transform-origin",
	underlinePosition: "underline-position",
	underlineThickness: "underline-thickness",
	unicodeBidi: "unicode-bidi",
	unicodeRange: "unicode-range",
	unitsPerEm: "units-per-em",
	vAlphabetic: "v-alphabetic",
	vHanging: "v-hanging",
	vIdeographic: "v-ideographic",
	vMathematical: "v-mathematical",
	vectorEffect: "vector-effect",
	vertAdvY: "vert-adv-y",
	vertOriginX: "vert-origin-x",
	vertOriginY: "vert-origin-y",
	wordSpacing: "word-spacing",
	writingMode: "writing-mode",
	xHeight: "x-height",
	// xlink/xml namespace attributes (deprecated in SVG 2 but still used)
	xlinkActuate: "xlink:actuate",
	xlinkArcrole: "xlink:arcrole",
	xlinkHref: "xlink:href",
	xlinkRole: "xlink:role",
	xlinkShow: "xlink:show",
	xlinkTitle: "xlink:title",
	xlinkType: "xlink:type",
	xmlBase: "xml:base",
	xmlLang: "xml:lang",
	xmlSpace: "xml:space",
	xmlnsXlink: "xmlns:xlink",
};
